import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=3ce247ef&scoped=true&"
import script from "./highlight.vue?vue&type=script&lang=ts&"
export * from "./highlight.vue?vue&type=script&lang=ts&"
import style0 from "./highlight.vue?vue&type=style&index=0&id=3ce247ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce247ef",
  null
  
)

export default component.exports